import * as React from "react";
import FuelCardTable from "../tables/FuelCardTable";
import { Card, CardContent, Stack } from "@mui/material";

function FuelCard() {

    return (
        <Card variant="outlined" sx={{margin: '15px'}}>
            <CardContent>
                <Stack direction={"column"} spacing={2} margin={"16px"}>
                    <FuelCardTable/>
                </Stack>
            </CardContent>
        </Card>
    )
}

export default FuelCard;